<template>
    <section>
        <titlebar :title-stack="titleStack"></titlebar>
        <div class="columns box">
            <div class="column is-5">
                <b-field>
                    <b-input :placeholder="$t('SISTEMA.PROCURAR')"
                             v-model="procurar"
                             icon="magnify"
                             @input="loadAsyncData"></b-input>
                </b-field>
            </div>
            <div class="column is-3">
                    <b-datepicker
                        v-model="filtroMes"
                        placeholder="Escolha o mês"
                        icon="calendar"
                        type="month"
                        @input="loadAsyncData"
                        editable >
                </b-datepicker>
            </div>
            <div class="column is-2">
                <b-field>
                    <b-select v-model="statusFiltro" :placeholder="$t('SISTEMA.STATUS')"  @input="loadAsyncData()" expanded>
                        <option value="Ativo">Ativo</option>
                        <option value="Inativo">Inativo</option>
                    </b-select>
                </b-field>
            </div>

            <div class="column">
                <div class="buttons">
                    <router-link v-if="isInRole('meta-alterar')" :to="{ name: 'meta' }" class="button is-primary">
                        {{$t('SISTEMA.INCLUIR')}}
                    </router-link>
                </div>
            </div>

        </div>
        <b-table :data="model.lista"
                 :loading="loading"
                 :paginated="false"
                 striped
                 hoverable
                 backend-pagination
                 :total="total"
                 @page-change="onPageChange"
                 :aria-next-label="$t('SISTEMA.PROXPAGINA')"
                 :aria-previous-label="$t('SISTEMA.PAGANTERIOR')"
                 :aria-page-label="$t('SISTEMA.PAGINA')"
                 :aria-current-label="$t('SISTEMA.PAGATUAL')"
                 backend-sorting
                 :default-sort-direction="defaultOrdenar"
                 :default-sort="[ordenarPor, ordenar]"
                 sort-icon-size="is-small"
                 @sort="onSort">

            <template  @click="abrirCadastro(props.row.id)">

                <b-table-column v-slot="props" field="Funcionario" :label="$t('SISTEMA.FUNCIONARIO')" >
                    {{ props.row.funcionario.nome }}
                </b-table-column>

                <b-table-column v-slot="props" field="Valor" :label="$t('SISTEMA.VALOR')" width="20%">
                    {{ props.row.valorMetaFormatado }}
                </b-table-column>

                <b-table-column v-slot="props" field="Data" :label="$t('SISTEMA.DATA')" width="20%">
                    {{ $moment(props.row.dataMes).format("MM/YYYY")}}
                </b-table-column>

                <b-table-column v-slot="props" custom-key="actions" numeric width="10%">
                    <router-link :to="{ name: 'meta', params: { id: props.row.id }}" class="button is-small is-primary" :title="$t('SISTEMA.EDITAR')">
                        <b-icon icon="pencil" size="is-small"></b-icon>
                    </router-link>
                    <b-button 
                        class="ml-2"
                        icon-left="delete"
                        type="is-danger"
                        size="is-small"
                        :title="$t('SISTEMA.REMOVER')"
                        @click="removerMeta(props.row.id)"></b-button>                                                
                </b-table-column>
            </template>
            <template #footer v-if="model.lista && model.lista.length > 0">
                <th > <div class="th-wrap"> </div> </th>
                <th >
                    <div class="th-wrap">  {{ retornarValorTotalMeta() }}  </div>
                </th>
                <th > <div class="th-wrap"> </div> </th>
                <th > <div class="th-wrap"> </div> </th>
            </template>     
        </b-table>
    </section>
</template>

<style scoped>
.datepicker-table{
    display: none !important;
}
</style>

<script>
    import { mapGetters,mapState } from 'vuex'    
    import titlebar from '@/components/titlebar.vue'

    export default {
        data() {
            return {
                model: [],
                total: 0,
                loading: false,
                procurar: this.$route.query.procurar ?? "",
                ordenarPor: 'Nome',
                ordenar: 'asc',
                defaultOrdenar: 'asc',
                page: 1,
                perPage: 20,
                selecionado: null,
                id: null,
                statusFiltro: "Ativo",
                filtroMes: new Date()
            }
        },
        components: {
            titlebar
        },
        computed: {
            ...mapState([                                
                'unidadeId',                
            ]),            
            titleStack() {
                return [
                    this.$t('SISTEMA.MANUTENCAO'),
                    this.$t('METASLISTA.METAS'),
                ]
            },
            ...mapGetters([
                'isInRole'
            ])
        },
        watch: {            
            unidadeId: function(novaUnidade) {                 
                this.loadAsyncData()                                                
            },
        },
        mounted() {
            this.loadAsyncData();
        },
        methods: {
            removerMeta(id){
                this.$buefy.dialog.confirm({
                    title: this.$t('SISTEMA.ATENCAO'),
                    message: this.$t('METASLISTA.REMOVERMETA'),
                    confirmText: this.$t('SISTEMA.CONFIRMAR'),
                    cancelText: this.$t('SISTEMA.CANCELAR'),
                    type: 'is-danger',
                    hasIcon: true,
                    onConfirm: () => {
                        this.loading = true;
                        this.$http.post('/api/manutencao/ExcluirMeta?id='+ id)
                            .then((res) => {
                                if (res.body.erro) {
                                    this.$buefy.toast.open({
                                        duration: 5000,
                                        message: res.body.erro,
                                        type: 'is-danger'
                                    })
                                } else {
                                    this.loadAsyncData()
                                }
                            })
                            .catch((error) => {
                                throw error
                            })
                            .finally(() => {
                                this.loading = false;
                                this.loadAsyncData();
                            });
                    }
                })
            },
            loadAsyncData() {
                console.log(this.filtroMes)
                const params = [
                    `procurar=${this.procurar}`,
                    `dataMes=${this.$moment(this.filtroMes).format("YYYY-MM")}`,
                    `ordem=${this.ordenarPor}.${this.ordenar}`,
                    `page=${this.page}`,
                    `perPage=${this.perPage}`,
                    `statusFiltro=${this.statusFiltro}`,
                ].join('&')

                this.loading = true
                this.$http.get(`/api/manutencao/metas?${params}`)
                    .then(({ data }) => {
                        this.model = data;
                        this.total = this.perPage * data.pageCount
                        this.loading = false
                    })
                    .catch((error) => {
                        this.model = []
                        this.total = 0
                        this.loading = false
                        throw error
                    })
            },
            onPageChange(page) {
                this.page = page
                this.loadAsyncData()
            },
            onSort(field, order) {
                this.ordenarPor = field
                this.ordenar = order
                this.loadAsyncData()
            },
            abrirCadastro() {                
                this.$router.push({ name: 'meta', params: {id: this.selecionado.id} })                                            
            },
            retornarValorTotalMeta() {
                let valorTotalMeta = 0.0;
                
                if(this.model.lista)
                    this.model.lista.forEach((item) => valorTotalMeta += item.valorMeta );                   

                return valorTotalMeta.toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL'
                });
            }
        }
    }
</script>